import React, { useState } from "react";
import { Modal, Button, Image } from "react-bootstrap";
import { amApi } from "../../../../../api/apiHelper";

export const SuperAdminDeleteExpCurationPage = ({
  id,
  active,
  onSuccess,
  title,
  subTitle,
}) => {
  const [showDelete, seShowDelete] = useState(false);

  const handleCloseDelete = async () => {
    await amApi.delete(`/admin/experience/${id}`);
    onDeleteNo();
    onSuccess(id, active);
  };

  const onDeleteNo = () => {
    seShowDelete(false);
  };

  const handleShowDelete = () => {
    seShowDelete(true);
  };

  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        disabled={false}
        onClick={handleShowDelete}
      >
        <Image
          src={require("../../../../../assets/images/UserManagement/Delete.svg")}
          alt="Delete"
          title="Delete"
          fluid
        />
      </Button>
      <Modal show={showDelete} onHide={onDeleteNo} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">{subTitle}</Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={onDeleteNo}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={handleCloseDelete}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

